var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOdienceLogoWhiteHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 448,
    height: 100.674,
    viewBox: "0 0 448 100.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-1",
    width: 448,
    height: 100.674
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M190.748,6.4V33.648l.457,0a22.2,22.2,0,0,1,0,44.408l-.178,0-.226,0-.133,0-.269-.007-.159-.007L190,78.021l-.169-.01L189.6,78l-.173-.013-.225-.019-.175-.016-.223-.023-.174-.019-.224-.027-.169-.021L188,77.823l-.153-.022q-.186-.028-.371-.06l-.191-.034-.191-.034-.206-.04-.173-.034-.213-.045-.161-.035-.22-.051-.149-.036-.228-.056-.134-.035-.241-.064-.108-.03-.264-.075-.045-.013c-.243-.071-.485-.148-.725-.227q-.473-.156-.936-.333l-.017-.006q-.161-.061-.32-.126l-.016-.006c-.151-.061-.3-.123-.451-.187l-.182-.08-.263-.117-.216-.1-.222-.1-.233-.114-.2-.1-.247-.127-.17-.09-.265-.143-.13-.073c-.1-.056-.2-.112-.3-.169l-.007,0q-.773-.45-1.5-.96l-.028-.019q-.174-.122-.346-.247l-.026-.019q-.177-.129-.352-.261h0a22.34,22.34,0,0,1-5.692-6.379q-.516-.87-.956-1.787l-.039-.083c-.035-.074-.07-.149-.1-.223q-.075-.165-.148-.331.056.142.115.287l.023.058c.3.729.64,1.5,1.036,2.31a38.905,38.905,0,0,0,7.2,10.1l.032.033.22.222.051.051.213.211.062.06.212.206.066.064.214.2.066.063.219.206.058.054.234.215.018.017q.405.37.829.737l.032.028.218.187.1.084.2.169.121.1.192.158.135.111.188.153.144.115.186.148.153.12.184.144.16.123.183.14.168.127.18.136.182.134.173.127.222.161.214.154.282.2.149.1.225.156.162.11.218.148.167.112.22.146.169.111.223.145.171.11.229.145.17.107.237.148.167.1.252.153.158.1.278.165.138.082.347.2.075.043.436.248.033.019.4.223.122.066.319.173.151.08.3.158.164.085h0l.29.15.171.087.293.148.172.086.3.147.171.084.313.15.162.077.339.158.143.066.394.179.094.043q.5.225,1.013.444l.075.032.433.182.142.058.372.153.17.068.353.14.183.072.347.134.191.073.348.131.193.072.357.131.189.068.375.133.177.062.414.143.144.049.528.176.036.012q.293.1.59.191l.01,0,.567.178.146.045.439.133.191.057.4.118.214.062.387.11.226.063.384.106.231.062.389.1.23.06.4.1.224.056.427.105.2.05.487.115.152.036q.648.15,1.311.293l.159.033.5.105.226.046.442.089.253.049.423.081.269.05.415.076.279.05.415.073.282.048.423.07.281.046.439.069.271.042.472.071.245.036.577.082.146.021.737.1.149.019.591.074.26.031.487.057.3.033.456.05.318.033.447.045.328.032.446.042.334.03.45.039.336.028.462.036.331.025.485.034.315.022.541.034.266.017.815.046A49.454,49.454,0,0,0,191.205,6.395h-.457",
    transform: "translate(-170.859 -6.395)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.563,
    y1: 0.448,
    x2: 0.446,
    y2: 0.772,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Odience-logo-White-Horizontal",
    transform: "translate(-2.585 -9.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(2.585 10.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 -0.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-3",
    d: "M89.881,93.78l-.267-.017-.541-.034-.315-.022-.485-.034-.331-.025-.462-.036-.335-.028-.45-.039-.334-.03-.446-.042-.328-.032-.447-.045-.318-.033-.456-.05-.3-.033-.487-.057-.26-.031-.591-.074-.149-.019q-.37-.048-.737-.1l-.146-.021-.577-.082-.245-.036-.473-.071-.271-.042-.439-.069-.281-.046-.423-.07-.282-.048-.415-.073-.279-.05-.415-.076-.269-.05-.423-.081-.253-.049-.442-.089L75.985,92l-.5-.105-.159-.034q-.663-.142-1.311-.292l-.152-.036-.487-.115-.205-.05-.427-.105-.224-.057-.4-.1-.23-.06-.389-.1-.23-.062-.385-.106-.226-.063-.387-.11-.214-.062-.4-.118-.191-.057-.439-.133-.146-.045-.567-.178-.01,0-.59-.191-.036-.012-.528-.177-.144-.049-.414-.143-.177-.062-.375-.133-.189-.069-.357-.13-.193-.072-.348-.131-.191-.073-.347-.134-.183-.072-.353-.14-.17-.068-.372-.153-.142-.058-.433-.182-.075-.032q-.513-.219-1.013-.444l-.094-.043-.394-.179-.143-.066-.339-.158-.162-.077-.313-.15-.171-.084-.3-.147-.172-.086-.293-.148-.17-.087-.29-.15h0l-.164-.085-.3-.158-.151-.08-.319-.173-.122-.066-.4-.223-.033-.019-.436-.248-.075-.043-.347-.2-.138-.082-.278-.165-.158-.1-.252-.153-.167-.1-.237-.148-.17-.107-.229-.145-.172-.11-.222-.145-.169-.111-.22-.146-.167-.111-.218-.148-.162-.11-.224-.156-.149-.1-.282-.2-.214-.154-.222-.161-.173-.127-.182-.134-.18-.136-.168-.127-.183-.14-.16-.123-.184-.144-.152-.12-.186-.148-.144-.115-.188-.153-.135-.111-.192-.158-.121-.1-.2-.169-.1-.084-.218-.187-.032-.028q-.424-.367-.829-.737l-.019-.017-.234-.215-.058-.054-.219-.206-.066-.062-.214-.2-.066-.064-.212-.206-.062-.06-.213-.211-.051-.051-.22-.222-.032-.033A38.372,38.372,0,0,1,38.8,65.093l-.023-.058q-.058-.145-.115-.287a22.031,22.031,0,0,1-1.614-5.6,22.366,22.366,0,0,1-.244-3.291c0-.038,0-.075,0-.113v0A22.2,22.2,0,0,1,48.932,36.065l0,0q.237-.121.477-.236l.021-.01q.231-.111.466-.217l.042-.018q.225-.1.451-.2l.062-.025c.145-.061.291-.12.437-.178l.081-.031c.141-.055.282-.109.424-.161l.1-.036c.136-.049.272-.1.409-.143l.123-.04c.131-.043.262-.087.394-.127l.14-.042c.127-.038.254-.077.382-.113l.159-.043c.123-.034.245-.068.368-.1l.179-.044c.118-.029.236-.059.354-.086l.2-.043c.113-.025.226-.051.34-.074l.216-.041c.109-.021.218-.043.327-.063l.232-.038c.105-.018.21-.036.316-.052.084-.013.169-.023.253-.035.1-.014.2-.029.3-.042s.185-.021.277-.032.186-.022.279-.032.2-.018.3-.027l.259-.023c.111-.008.222-.014.334-.021l.231-.015c.122-.006.245-.01.368-.014l.2-.008c.131,0,.263,0,.394-.005V6.4A49.456,49.456,0,0,0,19.268,85.288l.008.011a49.5,49.5,0,0,0,39.558,20.009h.178A49.252,49.252,0,0,0,90.7,93.825l-.815-.045",
    transform: "translate(-6.133 -5.518)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(32.532 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    className: "cls-4",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-5",
    width: 118.743,
    height: 126.503,
    transform: "translate(-24.433 -19.561)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 -0.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-3",
    d: "M714.924,177.6c10.725,0,18.111,7.917,18.114,18.588s-7.378,18.6-18.1,18.6-18.111-7.917-18.114-18.589,7.378-18.6,18.1-18.6m0,4.8c-7.707,0-12.556,5.878-12.554,13.8,0,7.869,4.854,13.8,12.561,13.793,7.6,0,12.556-5.932,12.554-13.8,0-7.922-4.962-13.8-12.561-13.794",
    transform: "translate(-569.373 -145.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-3",
    d: "M1020.229,180.8l12.827,0c11.21,0,18.65,7.648,18.652,18,0,10.4-7.432,17.949-18.642,17.952l-12.827,0Zm12.835,31.2c8.3,0,13.095-5.932,13.093-13.208,0-7.384-4.639-13.257-13.1-13.254l-7.437,0,.007,26.462Z",
    transform: "translate(-834.419 -148.444)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    className: "cls-3",
    width: 5.389,
    height: 35.948,
    transform: "translate(239.439 32.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-3",
    d: "M1478.349,180.659l24.145-.007V185.4l-18.755.005,0,10.509,18.378-.005v4.743l-18.378.005,0,11.21,18.755-.005V216.6l-24.145.007Z",
    transform: "translate(-1209.866 -148.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-3",
    d: "M1741.473,188.931l.008,27.594-5.389,0-.01-35.948,5.551,0,19.571,26.942-.008-26.947,5.389,0,.01,35.948h-5.228Z",
    transform: "translate(-1421.088 -148.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-3",
    d: "M2027.586,195.821c0-11.048,8.187-18.6,18.427-18.6a16.256,16.256,0,0,1,14.284,7.6l-4.58,2.426a11.4,11.4,0,0,0-9.7-5.225c-7.276,0-12.879,5.716-12.877,13.8,0,8.03,5.609,13.8,12.885,13.793a11.394,11.394,0,0,0,9.7-5.23l4.582,2.424a16.324,16.324,0,0,1-14.28,7.6c-10.24,0-18.434-7.54-18.437-18.588",
    transform: "translate(-1659.987 -145.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-3",
    d: "M2325.306,180.422l24.145-.007v4.743l-18.755.005,0,10.509,18.378-.005v4.743l-18.378.005,0,11.21,18.755-.005v4.743l-24.145.007Z",
    transform: "translate(-1903.981 -148.129)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdienceLogoWhiteHorizontal);
export default __webpack_public_path__ + "static/media/Odience-logo-White-Horizontal.4fc9566d598ea5db08032b2c652763bf.svg";
export { ForwardRef as ReactComponent };